import graphql__4841ab9ad9909becfdc0 from "./__generated__/SitemapManagerQuery.graphql.js";import { graphql } from "react-relay";

import AppQueryRenderer from "../AppQueryRenderer";
import { ResourcesListProvider } from "../ResourcesList/resourcesList";

import Sitemap from "./Sitemap";

const SitemapManager = () => {
  return (
    <ResourcesListProvider>
      <AppQueryRenderer query={SitemapManagerQuery} component={Sitemap} />
    </ResourcesListProvider>
  );
};

const SitemapManagerQuery = graphql__4841ab9ad9909becfdc0;

export default SitemapManager;
